<template>
  <div class="slideBar" style="display: block;">
    <div class="slide slide1">
        <div class="front">
            <div class="icon"></div>
            <div class="text">抖音号</div>
            <div class="line"></div>
        </div>
        <div class="info-box clearfix">
            <div class="list">
                <div class="img">
                    <img src="../../static/dy_code.png" alt="">
                </div>
                <div class="txt">能源人力抖音号</div>
            </div>
        </div>
    </div>
    <div class="slide slide2">
        <div class="front">
            <div class="icon"></div>
            <div class="text">公众号</div>
            <div class="line"></div>
        </div>
        <div class="info-box clearfix">
			<div class="list">
                <div class="img">
                    <img src="../../static/nyrl_code.jpg" alt="">
                </div>
                <div class="txt">能源人力公众号</div>
            </div>
            <div class="list ">
                <div class="img">
                    <img src="../../static/zync_code.png" alt="">
                </div>
                <div class="txt">中原能才公众号</div>
            </div>
        </div>
    </div>
    <div class="slide slide3">
        <div class="front">
            <div class="icon"></div>
            <div class="text">小程序</div>
            <div class="line"></div>
        </div>
        <div class="info-box clearfix">
			            <div class="list ">
                <div class="img">
                    <img src="../../static/zync.png" alt="">
                </div>
                <div class="txt">中原能才小程序</div>
            </div>
            <div class="list ">
                <div class="img">
                    <img src="../../static/yhg_code.jpg" alt="">
                </div>
                <div class="txt">豫好工小程序</div>
            </div>
            <!-- <div class="list">
                <div class="img">
                    <img src="../../static/nct_code.jpg" alt="">
                </div>
                <div class="txt">能才通小程序</div>
            </div> -->
        </div>
    </div>
    <div class="slide slide5">
        <div class="front">
            <div class="icon"></div>
            <div class="text">福利平台</div>
            <div class="line"></div>
        </div>
        <div class="info-box clearfix">
			            <div class="list ">
                <div class="img">
                    <img src="../../static/flpt.png" alt="">
                </div>
                <div class="txt">福利平台</div>
            </div>
		</div>
    </div>

    <div class="slide slide4" @click="gotoTop">
        <div class="front">
            <div class="icon"></div>
            <div class="text">返回顶部</div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    methods: {
        gotoTop() {
            this.$emit("gotoTop")
        }
    },
}
</script>
<style scoped>
.slideBar{
	position: fixed;
	bottom: 100px;
	right: 42px;
	box-shadow: 0 0 0.1rem rgba(0,0,0,0.1);
	width: 80px;
	border-radius: 19px;
	/* overflow: hidden; */
	z-index: 9;
	background-color: #fff;
	display: none;
}
.slideBar .slide{
    width: 100%;
	cursor: pointer;
	position: relative;
	padding-top: 12px;
}
.slideBar .icon{
	height: 38px;
	width: 100%;
}
.slideBar .text{
	font-size: 16px;
	color: #999999;
	text-align: center;
	line-height: 1;
	padding: 5px 0 15px;
    width: 100%;
}
.slideBar .line{
	width: 25px;
	height: 1px;
	background-color: #ebebeb;
	margin: 0 auto;
}
.slideBar .slide1 .icon{
	background: url(../../static/slideBar/sIcon39.png) center no-repeat;
	background-size: 30px auto;
}
.slideBar .slide2 .icon{
	background: url(../../static/slideBar/sIcon40.png) center no-repeat;
	background-size: 36px auto;
}
.slideBar .slide3 .icon{
	background: url(../../static/slideBar/sIcon41.png) center no-repeat;
	background-size: 32px auto;
}
.slideBar .slide4 .icon{
	background: url(../../static/slideBar/sIcon42_s.png) center no-repeat;
	background-size: 34px auto;
}

.slideBar .slide5 .icon{
	background: url(../../static/slideBar/fuli.png) center no-repeat;
	background-size: 34px auto;
}

.slideBar .slide4{
	/*background-color: #a60b09;*/
	border-bottom-left-radius: 19px;
	border-bottom-right-radius: 19px;
	/* padding-bottom: 12px; */
}
.slideBar .slide4 .text{
	/*color: #ffffff;*/
}
.slideBar .info-box{
	position: absolute;
	right: calc(100% + 30px);
	top: 50%;
	transform: translateY(-50%);
	background: #ffffff;
	/* background-size: auto 100%; */
	box-shadow: 0 0 10px rgba(0,0,0,0.4);
	padding: 16px;
	width: 162px;
	box-sizing: border-box;
	display: none;
	transition-duration: 0.5s;
}
.slideBar .info-box::before{
	content: '';
	position: absolute;
	width: 26px;
	height: 35px;
	background: url(../../static/slideBar/sIcon45.png) center no-repeat;
	background-size: contain;
	right: -26px;
	top: 50%;
	transform: translateY(-50%);
}
.slideBar .slide2 .info-box{
	width: 302px;
	/* display: block; */
}
.slideBar .info-box .list{
	margin-right: 10px;
	float: left;
	width: 130px;
}
.slideBar .info-box .list:last-child{
	margin-right: 0;
}
.slideBar .info-box  .txt{
	font-size: 14px;
	color: #333333;
	line-height: 22px;
	padding: 0 15px;
	text-align: center;
}
.slideBar .info-box .img{
	/* margin-right: 40px; */
	width: 130px;
}
.slideBar .info-box .img img{
	width: 100%;
}
.slideBar .slide:hover .info-box{
	display: block;
}
.slideBar .slide4:hover{
    background-color: #c8000a;
}
.slideBar .slide4:hover .icon{
    background-image: url(../../static/slideBar/sIcon42.png);
}
.slideBar .slide:hover .text{
	color: #333333;
}
.slideBar .slide4:hover .text{
	color: #ffffff;
}
.slideBar .slide1:hover .icon{
	background-image: url(../../static/slideBar/sIcon39_s.png);
}
.slideBar .slide2:hover .icon{
	background-image: url(../../static/slideBar/sIcon40_s.png);
}

.slideBar .slide3 .info-box{
	width: 320px;
	/* display: block; */
}

.slideBar .slide3:hover .icon{
	background-image: url(../../static/slideBar/sIcon41_s.png);
}

body{
	font-family: arial, helvetica, sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/components/SideBar.vue